var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapTileSold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-tile-sold") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 72.5,
    cy: 57.5,
    r: 41.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-tile-sold"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Map-Icon-Circle-Default",
    transform: "translate(2.000000, 16.000000)",
    fillOpacity: 0.1,
    fill: "#2E8FFA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Square",
    transform: "translate(3.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9246481,0.728520014 L137.960144,23.2411971 C140.679952,24.2125571 140.679952,25.7874429 137.960144,26.7588029 L74.9246481,49.27148 C72.2048401,50.24284 67.7951599,50.24284 65.0753519,49.27148 L2.03985604,26.7588029 C-0.679952013,25.7874429 -0.679952013,24.2125571 2.03985604,23.2411971 L65.0753519,0.728520014 C67.7951599,-0.242840005 72.2048401,-0.242840005 74.9246481,0.728520014 Z",
    id: "Rectangle-2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sold-sign",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    stroke: "none",
    fill: "#304060",
    fillRule: "evenodd",
    x: 26.9289617,
    y: 1.93442623,
    width: 9.79234973,
    height: 55.4535519
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "none",
    fill: "#304060",
    fillRule: "evenodd",
    cx: 31.8251366,
    cy: 56.7431694,
    rx: 4.89617486,
    ry: 2.2568306
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "none",
    fill: "#495A7A",
    fillRule: "evenodd",
    cx: 31.8251366,
    cy: 2.2568306,
    rx: 4.89617486,
    ry: 2.2568306
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-43",
    stroke: "none",
    fill: "#DB7373",
    fillRule: "evenodd",
    points: "6.03099656 21.0756894 0 19.1647028 0.101173824 42.7469162 6.16965123 45.8315573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Path-40",
    stroke: "#979797",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-42",
    stroke: "none",
    fill: "#E86B6B",
    fillRule: "evenodd",
    points: "63.5456016 2.45327833 56.8689749 0.639961519 0.0522743445 19.3736593 5.93098018 21.0854175"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-41",
    stroke: "none",
    fill: "#E33E3E",
    fillRule: "evenodd",
    points: "63.5369143 2.44914939 63.5369143 26.7155391 5.99561893 45.7435459 5.99561893 21.0287824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7461543,32.5785738 C14.7461543,32.0858956 14.5933817,31.7497279 14.287832,31.5700607 C13.9822822,31.3903935 13.4454758,31.2733859 12.6773966,31.2190344 C11.9093175,31.1646829 11.2814081,31.0761391 10.7936498,30.9534005 C9.2070337,30.5597366 8.41373754,29.5855114 8.41373754,28.0306957 C8.41373754,27.256487 8.61136079,26.5117215 9.00661322,25.7963766 C9.40186564,25.0810317 9.96109739,24.4456282 10.6843252,23.8901471 C11.4075531,23.334666 12.2204714,22.9159241 13.1231046,22.6339088 C14.0033121,22.3589002 14.7924035,22.2915125 15.4904025,22.4317438 C16.1884015,22.5719751 16.7308142,22.9127719 17.117657,23.4541446 C17.5044998,23.9955172 17.6979183,24.6916879 17.6979183,25.5426775 L14.7545639,26.462288 C14.7545639,25.8928287 14.6017913,25.4990762 14.2962416,25.2810185 C13.9906918,25.0629607 13.5772247,25.0353839 13.0558279,25.1982872 C12.5288247,25.362942 12.1125544,25.6257651 11.8070047,25.9867643 C11.501455,26.3477635 11.3486824,26.7330067 11.3486824,27.1425054 C11.3486824,27.5008169 11.5168724,27.7729831 11.8532574,27.9590123 C12.1896425,28.1450415 12.7811106,28.2609666 13.6276796,28.3067911 C14.4742487,28.3526156 15.169434,28.4697269 15.7132565,28.6581285 C17.036371,29.1149245 17.6979183,30.1079187 17.6979183,31.6371407 C17.6979183,32.8592387 17.2942623,33.9451038 16.4869382,34.8947687 C15.6796141,35.8444336 14.5723633,36.5390874 13.1651525,36.9787509 C12.1728166,37.2887926 11.2744017,37.3663432 10.4698808,37.211405 C9.66535994,37.0564669 9.05987595,36.688988 8.65341069,36.1089572 C8.24694543,35.5289264 8.04371585,34.7782361 8.04371585,33.8568638 L11.0038894,32.9319985 C11.0038894,33.6806135 11.173481,34.1794822 11.5126693,34.4286198 C11.8518575,34.6777573 12.4026798,34.683214 13.1651525,34.4449899 C13.6529108,34.2925965 14.0383462,34.052204 14.3214703,33.7238051 C14.6045944,33.3954062 14.7461543,33.0136662 14.7461543,32.5785738 Z M29.5806605,24.9588898 C29.5806605,26.321753 29.3592104,27.5970258 28.9163034,28.7847466 C28.4733964,29.9724675 27.8440855,30.9768752 27.0283518,31.798 C26.2126181,32.6191247 25.2833683,33.1925818 24.2405747,33.5183882 C23.1977811,33.8441947 22.2727361,33.859684 21.465412,33.5648564 C20.6580879,33.2700289 20.0287769,32.6844535 19.5774603,31.8081126 C19.1261437,30.9317717 18.8892762,29.8380838 18.8668505,28.5270162 L18.8668505,27.7400146 C18.8668505,26.3707531 19.0868991,25.0943186 19.5270028,23.9106728 C19.9671066,22.727027 20.5978191,21.7221814 21.4191592,20.8961057 C22.2404994,20.0700301 23.1753555,19.4932219 24.2237555,19.1656638 C25.2609427,18.8416089 26.1859877,18.8341176 26.9989183,19.1431895 C27.8118488,19.4522614 28.4439629,20.056156 28.8952795,20.9548914 C29.346596,21.8536268 29.5750541,22.9739358 29.5806605,24.315852 L29.5806605,24.9588898 Z M26.5784391,25.3114401 C26.5784391,23.9229833 26.3752095,22.9323559 25.9687442,22.3395283 C25.5622789,21.7467007 24.9806219,21.5685258 24.2237555,21.8049982 C22.7436613,22.2674332 21.9615778,23.7786522 21.8774816,26.3387007 L21.869072,27.3682692 C21.869072,28.7375308 22.0680968,29.7278723 22.4661525,30.3393234 C22.8642081,30.9507746 23.4556763,31.133882 24.2405747,30.8886514 C24.9862282,30.6556822 25.5608774,30.1146358 25.9645394,29.2654959 C26.3682015,28.4163559 26.5728326,27.3126944 26.5784391,25.954478 L26.5784391,25.3114401 Z M34.0545593,27.6688461 L39.1928151,26.0634691 L39.1928151,28.6548156 L31.1027953,31.1824306 L31.1027953,17.2083544 L34.0545593,16.2861165 L34.0545593,27.6688461 Z M50.4616577,23.406457 C50.0075379,24.1241981 49.3431874,24.7956436 48.4685863,25.4208137 C47.5939852,26.0459838 46.6353022,26.5214649 45.5925085,26.8472714 C43.9890732,27.3482426 42.708026,27.1886349 41.7493286,26.3684434 C40.7906313,25.5482519 40.2776518,24.1505337 40.2103748,22.1752469 L40.2019652,20.9685793 C40.2019652,19.5929193 40.4150058,18.3250726 40.8410936,17.1650012 C41.2671813,16.0049298 41.87687,15.0242482 42.6701781,14.2229268 C43.4634862,13.4216055 44.3815232,12.85805 45.4243169,12.5322435 C46.9492624,12.0557954 48.1336003,12.0840609 48.9773661,12.6170411 C49.8211319,13.1500212 50.3130877,14.1848048 50.4532481,15.721423 L47.6108087,16.609504 C47.5098932,15.8604265 47.2912462,15.3720857 46.9548612,15.1444668 C46.6184761,14.9168479 46.1419378,14.8993794 45.5252319,15.0920606 C44.7851848,15.3232781 44.2133388,15.8602495 43.8096767,16.702991 C43.4060147,17.5457326 43.2013835,18.6333983 43.1957771,19.9660211 L43.1957771,20.8106081 C43.1957771,22.2054633 43.404613,23.1879407 43.8222911,23.7580698 C44.2399692,24.3281989 44.8973118,24.4731294 45.7943386,24.1928658 C46.5624177,23.9528901 47.1342637,23.5790759 47.5098937,23.0714119 L47.5098937,20.9023589 L45.4579552,21.5434587 L45.4579552,19.230442 L50.4616577,17.6671043 L50.4616577,23.406457 Z M61.7893674,10.2217028 L58.1143792,11.3699021 L58.1143792,22.7430342 L55.1626152,23.6652721 L55.1626152,12.29214 L51.5549036,13.4193197 L51.5549036,10.8183756 L61.7893674,7.62075868 L61.7893674,10.2217028 Z",
    id: "SOLGT",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTileSold);
export default __webpack_public_path__ + "static/media/map-tile-sold.0e2997af.svg";
export { ForwardRef as ReactComponent };